
interface Props {
    data: {
        color: string,
        value: number | string
    }[]
}

export const ProgressBar = ({ data }: Props) => {
    const total = data.reduce((sum, value) => sum + Number(value.value), 0);

    return (
      <div className="flex w-full items-center justify-center h-[30px] overflow-hidden rounded-[5px]">
        {data.map((value, index) => {
          const percentage = (Number(value.value) / total) * 100;
          return (
            <div
              key={index}
              className={`flex justify-center items-center h-full text-[12px] text-white font-bold`}
              style={{ width: `${percentage}%`, backgroundColor: value.color }}
            >
              {percentage >= 10 ? `${percentage.toFixed(2)}%` : null}
            </div>
          );
        })}
      </div>
    );
};
